import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { WsDayType, WsEmployee, WsEmployeeLookup, WsEvent, WsProdCalendarDay } from "../../shared/components/work-schedule/core/work-schedule.models";
import { WorkScheduleService } from "../../shared/services/work-schedule.service";
import { forkJoin, Observable } from "rxjs";

@Component({
  selector: 'work-schedules',
  templateUrl: './work-schedules.page.html',
  styleUrls: ['./work-schedules.page.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WorkSchedulesPage implements OnInit, OnDestroy {
  wsVisible = false;
  date: Date = new Date();
  prodCalendarDays: WsProdCalendarDay[] = [];
  employees: WsEmployee[] = [];
  employeesForLookup: WsEmployeeLookup[] = [];

  constructor(public workScheduleService: WorkScheduleService) {

  }

  ngOnDestroy(): void {
    // throw new Error("Method not implemented.");
  }

  ngOnInit(): void {
    this.wsVisible = true;

    // const getProdCalendar$ = this.workScheduleService.getProdCalendar(this.date.getFullYear());
    // const getEmployeesLookup$ = this.workScheduleService.getEmployeesLookup();
    // const getEmployees$ = this.workScheduleService.getEmployees(0, 0);

    // forkJoin([getProdCalendar$, getEmployeesLookup$, getEmployees$]).subscribe(([prodCalendars, employeesForLookup, employees]) => {
    //   this.prodCalendarDays = prodCalendars;
    //   this.employees = employees;
    //   this.employeesForLookup = employeesForLookup;
    //   this.wsVisible = true;
    // })
  }

  


  // employees: WsEmployee[] = [
  //   {
  //     id: 1,
  //     name: 'Иванов Сергей',
  //     shiftLabel: '5/2',
  //     workDays: [1, 2, 3, 4, 5],   // Пн–Пт
  //   },
  //   {
  //     id: 2,
  //     name: 'Петров Антон',
  //     shiftLabel: '2/2',
  //     workDays: [1, 2, 5, 6],      // напр., Пн–Вт и Пт–Сб
  //   },
  //   {
  //     id: 3,
  //     name: 'Бессараб Никита Сергеевич',
  //     shiftLabel: '5/2',
  //     workDays: [1, 2, 3, 4, 5],
  //   },
  //   {
  //     id: 4,
  //     name: 'Иванов Иван Иваныч',
  //     shiftLabel: '5/2',
  //     workDays: [1, 2, 3, 4, 5],
  //   },
  //   {
  //     id: 5,
  //     name: 'Иванов Иван Иваныч',
  //     shiftLabel: '5/2',
  //     workDays: [1, 2, 3, 4, 5],
  //   },
  //   {
  //     id: 6,
  //     name: 'Иванов Иван Иваныч',
  //     shiftLabel: '5/2',
  //     workDays: [1, 2, 3, 4, 5],
  //   },
  //   {
  //     id: 7,
  //     name: 'Иванов Иван Иваныч',
  //     shiftLabel: '5/2',
  //     workDays: [1, 2, 3, 4, 5],
  //   },
  //   {
  //     id: 8,
  //     name: 'Иванов Иван Иваныч',
  //     shiftLabel: '5/2',
  //     workDays: [1, 2, 3, 4, 5],
  //   },
  //   {
  //     id: 9,
  //     name: 'Иванов Иван Иваныч',
  //     shiftLabel: '5/2',
  //     workDays: [1, 2, 3, 4, 5],
  //   },
  //   {
  //     id: 10,
  //     name: 'Иванов Иван Иваныч',
  //     shiftLabel: '5/2',
  //     workDays: [1, 2, 3, 4, 5],
  //   },
  //   // {
  //   //   id: 11,
  //   //   name: 'Иванов Иван Иваныч',
  //   //   shiftLabel: '5/2',
  //   //   workDays: [1, 2, 3, 4, 5],
  //   // },
  //   // {
  //   //   id: 12,
  //   //   name: 'Иванов Иван Иваныч',
  //   //   shiftLabel: '5/2',
  //   //   workDays: [1, 2, 3, 4, 5],
  //   // },
  //   // {
  //   //   id: 13,
  //   //   name: 'Иванов Иван Иваныч',
  //   //   shiftLabel: '5/2',
  //   //   workDays: [1, 2, 3, 4, 5],
  //   // },
  //   // {
  //   //   id: 14,
  //   //   name: 'Иванов Иван Иваныч',
  //   //   shiftLabel: '5/2',
  //   //   workDays: [1, 2, 3, 4, 5],
  //   // },
  //   // {
  //   //   id: 15,
  //   //   name: 'Иванов Иван Иваныч',
  //   //   shiftLabel: '5/2',
  //   //   workDays: [1, 2, 3, 4, 5],
  //   // },
  //   // {
  //   //   id: 16,
  //   //   name: 'Иванов Иван Иваныч',
  //   //   shiftLabel: '5/2',
  //   //   workDays: [1, 2, 3, 4, 5],
  //   // },
  //   // {
  //   //   id: 17,
  //   //   name: 'Иванов Иван Иваныч',
  //   //   shiftLabel: '5/2',
  //   //   workDays: [1, 2, 3, 4, 5],
  //   // },
  //   // {
  //   //   id: 18,
  //   //   name: 'Иванов Иван Иваныч',
  //   //   shiftLabel: '5/2',
  //   //   workDays: [1, 2, 3, 4, 5],
  //   // },
  //   // {
  //   //   id: 19,
  //   //   name: 'Иванов Иван Иваныч',
  //   //   shiftLabel: '5/2',
  //   //   workDays: [1, 2, 3, 4, 5],
  //   // },
  //   // {
  //   //   id: 20,
  //   //   name: 'Иванов Иван Иваныч',
  //   //   shiftLabel: '5/2',
  //   //   workDays: [1, 2, 3, 4, 5],
  //   // },
  //   // {
  //   //   id: 21,
  //   //   name: 'Иванов Иван Иваныч',
  //   //   shiftLabel: '5/2',
  //   //   workDays: [1, 2, 3, 4, 5],
  //   // },
  //   // {
  //   //   id: 22,
  //   //   name: 'Иванов Иван Иваныч',
  //   //   shiftLabel: '5/2',
  //   //   workDays: [1, 2, 3, 4, 5],
  //   // },
  //   // {
  //   //   id: 23,
  //   //   name: 'Иванов Иван Иваныч',
  //   //   shiftLabel: '5/2',
  //   //   workDays: [1, 2, 3, 4, 5],
  //   // },
  //   // {
  //   //   id: 24,
  //   //   name: 'Иванов Иван Иваныч',
  //   //   shiftLabel: '5/2',
  //   //   workDays: [1, 2, 3, 4, 5],
  //   // },
  //   // {
  //   //   id: 25,
  //   //   name: 'Иванов Иван Иваныч',
  //   //   shiftLabel: '5/2',
  //   //   workDays: [1, 2, 3, 4, 5],
  //   // },
  //   // {
  //   //   id: 26,
  //   //   name: 'Иванов Иван Иваныч',
  //   //   shiftLabel: '5/2',
  //   //   workDays: [1, 2, 3, 4, 5],
  //   // },
  //   // {
  //   //   id: 27,
  //   //   name: 'Иванов Иван Иваныч',
  //   //   shiftLabel: '5/2',
  //   //   workDays: [1, 2, 3, 4, 5],
  //   // },
  //   // {
  //   //   id: 28,
  //   //   name: 'Иванов Иван Иваныч',
  //   //   shiftLabel: '5/2',
  //   //   workDays: [1, 2, 3, 4, 5],
  //   // }
  // ];


  events: WsEvent[] = [
    // { id: 'ev1', employeeId: 1, type: 'vac', start: new Date('2025-10-10'), end: new Date('2025-10-12'), icon: "" },
    // { id: 'ev2', employeeId: 2, type: 'sick', start: new Date('2025-10-10'), end: new Date('2025-10-12'), icon: "" }
  ];
}